/* globals $ */
import Component from '../components/component';
import debounce from '../modules/debounce';
import imagesLoaded from '../vendors/imagesloaded.min';
import navSearch from '../modules/header';
import background from '../modules/background';
import hiddenArea from '../modules/hiddenArea';

/* eslint-disable react/prefer-stateless-function, react/sort-comp */

const defaults = {};

export default class Page extends Component {

  constructor($context, options) {
    super(defaults, options);

    this.$context = $context;

    this.$main = this.$context.find('main');
    this.$window = $(window);
    // TODO: poprawić selector lub w zasadzie to przenieść inicjalizacje do oddzielnego komponentu
    // tak samo jak i poniższą logikę
    // ale na ten moment zostaje
    this.$header = $('body').children('header');
    this.$aside = $('aside.sticky');

    this.initPage();
  }

  initPage() {
    this.initPageModules();

    imagesLoaded('body > header').on('done', () => {
      this.setHeaderDistance();
    });
    this.eventSetHeaderDistanceOnResize();
  }

  initPageModules() {
    navSearch();
    background();
    hiddenArea();
  }

  eventSetHeaderDistanceOnResize() {
    this.$window.on('resize', debounce(this.setHeaderDistance.bind(this), 200));
  }

  setHeaderDistance() {
    const height = this.$header.outerHeight(true);
    const $overlay = this.$header.find('.overlay');

    this.$main.css('padding-top', height);

    this.$aside.css({
      top: height + 43,
    });

    $overlay.css({
      top: height,
      height: `calc(100% - ${height})`,
    });
  }

  static initialize(selector = 'body', ClassName = Page, classNameString = 'Page', $context = $(document), options = {}) {
    return super.initialize(selector, ClassName, classNameString, $context, options);
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/pages/page.js